import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '@shared/components/base.component';
import { EventsServicePublic } from '@layouts/default/layouts/guest/pages/events/events.service';
import { Event } from '@shared/models/event.model';
import { RoutesPath } from '@shared/routes-path';
import { EventsHeader } from '@shared/interfaces/events-header/events-header.interface';

@Component({
  selector: 'app-events-carousel',
  templateUrl: './events-carousel.component.html',
  styleUrls: ['./events-carousel.component.scss'],
})
export class EventsCarouselComponent extends BaseComponent implements OnInit {
  @Input() filterCategory: string;
  @Input() font: string = '$font-family-base';
  @Input() buttonLink = RoutesPath.default.events;
  @Input() eventsHeader: EventsHeader = {
    title: 'HOMEPAGE.events_title',
    subtitle: 'HOMEPAGE.events_subtitle',
  };

  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 530,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  events: Event[] = [];

  constructor(private eventService: EventsServicePublic) {
    super();
  }

  ngOnInit() {
    this.getEvents();
  }

  getEvents() {
    const eventsList = this.eventService.getEvents(this.filterCategory).subscribe((el) => {
      this.events = el.data;
    }, this.onGetEventsError.bind(this));
    this.someSubscriptions.add(eventsList);
  }

  onGetEventsError(error: Error) {
    this.toast.error(
      this.translate.instant('HOMEPAGE.events_error'),
      this.translate.instant('HOMEPAGE.cant_get_events_list')
    );
  }
}
